enum PaymentCategory {
  AVTALEGIRO = 'AVTALEGIRO',
  DIGIPOST = 'DIGIPOST',
  EFAKTURA = 'EFAKTURA',
  INTERNATIONAL = 'INTERNATIONAL',
  LOAN = 'LOAN',
  MANUAL = 'MANUAL',
  OTHER = 'OTHER',
  TRANSFER = 'TRANSFER',
}

export default PaymentCategory;
